{
  "labels": {
    "paste": "הדבקה",
    "pasteAsPlaintext": "הדבקה ללא עיצוב",
    "pasteCharts": "הדבקת תרשימים",
    "selectAll": "בחירה בהכול",
    "multiSelect": "הוספת רכיב לבחירה",
    "moveCanvas": "הזזת הקנבס",
    "cut": "גזירה",
    "copy": "העתקה",
    "copyAsPng": "העתקה ללוח כ־PNG",
    "copyAsSvg": "העתקה ללוח כ־SVG",
    "copyText": "העתק ללוח כטקסט",
    "copySource": "העתקת המקור ללוח הגזירים",
    "convertToCode": "המרה לקוד",
    "bringForward": "קירוב השכבה",
    "sendToBack": "הרחקה אחורה",
    "bringToFront": "קירוב לחזית",
    "sendBackward": "הרחקה אחורה עד הסוף",
    "delete": "מחיקה",
    "copyStyles": "העתקת סגנון",
    "pasteStyles": "הדבקת סגנונות",
    "stroke": "קו מתאר",
    "changeStroke": "החלפת צבע קו מתאר",
    "background": "רקע",
    "changeBackground": "החלפת צבע הרקע",
    "fill": "מילוי",
    "strokeWidth": "עובי קו מתאר",
    "strokeStyle": "סגנון קו המתאר",
    "strokeStyle_solid": "מלא",
    "strokeStyle_dashed": "מקווקו",
    "strokeStyle_dotted": "מנוקד",
    "sloppiness": "רישול",
    "opacity": "אטימות",
    "textAlign": "יישור טקסט",
    "edges": "קצוות",
    "sharp": "חד",
    "round": "עגול",
    "arrowheads": "ראשי חצים",
    "arrowhead_none": "ללא",
    "arrowhead_arrow": "חץ",
    "arrowhead_bar": "קצה אנכי",
    "arrowhead_circle": "עיגול",
    "arrowhead_circle_outline": "עיגול (קו מתאר)",
    "arrowhead_triangle": "משולש",
    "arrowhead_triangle_outline": "משולש (קו מתאר)",
    "arrowhead_diamond": "יהלום",
    "arrowhead_diamond_outline": "יהלום (קו מתאר)",
    "arrowhead_crowfoot_many": "רגל עורב (הרבה)",
    "arrowhead_crowfoot_one": "רגל עורב (אחת)",
    "arrowhead_crowfoot_one_or_many": "רגל עורב (אחת או הרבה)",
    "more_options": "אפשרויות נוספות",
    "arrowtypes": "סוג החץ",
    "arrowtype_sharp": "חץ מחודד",
    "arrowtype_round": "חץ מעוקל",
    "arrowtype_elbowed": "חץ זוויתי",
    "fontSize": "גודל גופן",
    "fontFamily": "גופן",
    "addWatermark": "הוספת „נוצר באמצעות Excalidraw”",
    "handDrawn": "ציור יד",
    "normal": "רגיל",
    "code": "קוד",
    "small": "קטן",
    "medium": "בינוני",
    "large": "גדול",
    "veryLarge": "גדול מאוד",
    "solid": "אחיד",
    "hachure": "קווים מקבילים קצרים להצגת כיוון וחדות שיפוע במפה",
    "zigzag": "זיגזג",
    "crossHatch": "קווים מוצלבים",
    "thin": "דק",
    "bold": "מודגש",
    "left": "שמאל",
    "center": "מרכז",
    "right": "ימין",
    "extraBold": "מודגש במיוחד",
    "architect": "אדריכלות",
    "artist": "אמן",
    "cartoonist": "קריקטוריסט",
    "fileTitle": "שם קובץ",
    "colorPicker": "בורר צבעים",
    "canvasColors": "בשימוש בקנבס",
    "canvasBackground": "רקע קנבס",
    "drawingCanvas": "קנבס ציור",
    "clearCanvas": "ניקוי הקנבס",
    "layers": "שכבות",
    "actions": "פעולות",
    "language": "שפה",
    "liveCollaboration": "התחלת שיתוף חי…",
    "duplicateSelection": "שכפול",
    "untitled": "ללא כותרת",
    "name": "שם",
    "yourName": "שמך",
    "madeWithExcalidraw": "נוצר באמצעות Excalidraw",
    "group": "קיבוץ הבחירה",
    "ungroup": "פירוק קבוצה",
    "collaborators": "שותפים",
    "toggleGrid": "הצגת/הסתרת רשת",
    "addToLibrary": "הוספה לספרייה",
    "removeFromLibrary": "הסרה מהספרייה",
    "libraryLoadingMessage": "הספרייה נטענת…",
    "libraries": "עיון בספריות",
    "loadingScene": "הסצנה נטענת…",
    "loadScene": "טעינת סצנה מקובץ",
    "align": "יישור",
    "alignTop": "יישור למעלה",
    "alignBottom": "יישור למטה",
    "alignLeft": "יישור לשמאל",
    "alignRight": "יישור לימין",
    "centerVertically": "מירכוז אנכי",
    "centerHorizontally": "מירכוז אופקי",
    "distributeHorizontally": "פיזור אופקי",
    "distributeVertically": "פיזור אנכי",
    "flipHorizontal": "היפוך אופקי",
    "flipVertical": "היפוך אנכי",
    "viewMode": "מצב תצוגה",
    "share": "שיתוף",
    "showStroke": "הצגת בורר צבע מברשת",
    "showBackground": "הצגת בורר צבע רקע",
    "showFonts": "הצגת בורר הגופנים",
    "toggleTheme": "החלפת מצב מואר/חשוך",
    "theme": "ערכת עיצוב",
    "personalLib": "ספריה פרטית",
    "excalidrawLib": "הספרייה של Excalidraw",
    "decreaseFontSize": "הקטנת הכתב",
    "increaseFontSize": "הגדלת הכתב",
    "unbindText": "ביטול קיבוע הטקסט",
    "bindText": "קיבוע הטקסט למיכל",
    "createContainerFromText": "אריזת טקסט במיכל",
    "link": {
      "edit": "עריכת קישור",
      "editEmbed": "עריכת קישור מוטמע",
      "create": "הוספת קישור",
      "label": "קישור",
      "labelEmbed": "קישור ושיבוץ",
      "empty": "לא נקבע קישור",
      "hint": "יש להקליד או להדביק את הקישור שלך כאן",
      "goToElement": "העברה לפריט היעד"
    },
    "lineEditor": {
      "edit": "עריכת קו",
      "editArrow": "עריכת חץ"
    },
    "polygon": {
      "breakPolygon": "",
      "convertToPolygon": ""
    },
    "elementLock": {
      "lock": "נעילה",
      "unlock": "ביטול נעילה",
      "lockAll": "לנעול הכל",
      "unlockAll": "שחרור הכול"
    },
    "statusPublished": "פורסם",
    "sidebarLock": "להשאיר את סרגל הצד פתוח",
    "selectAllElementsInFrame": "בחירת כל הרכיבים במסגרת",
    "removeAllElementsFromFrame": "הסרת כל הרכיבים מהמסגרת",
    "eyeDropper": "בחירת צבע מתוך הקנבס",
    "textToDiagram": "טקסט לתרשים",
    "prompt": "בקשה",
    "followUs": "לעקוב אחרינו",
    "discordChat": "צ׳אט ב־Discord",
    "zoomToFitViewport": "התאמת התקריב לגודל המסך",
    "zoomToFitSelection": "להתמקד בחלק הנבחר",
    "zoomToFit": "להציג את כל הרכיבים",
    "installPWA": "התקנת Excalidraw לשימוש מקומי (PWA)",
    "autoResize": "לאפשר התאמה אוטומטית של גודל הכתב",
    "imageCropping": "חיתוך תמונה",
    "unCroppedDimension": "ממדים ללא חיתוך",
    "copyElementLink": "העתקת קישור לפריט",
    "linkToElement": "קישור לפריט",
    "wrapSelectionInFrame": "לעטוף את הבחירה במסגרת",
    "tab": "",
    "shapeSwitch": ""
  },
  "elementLink": {
    "title": "קישור לפריט",
    "desc": "יש ללחוץ על צורה בקנבס או להדביק קישור.",
    "notFound": "פריט מקושר לא נמצא בקנבס."
  },
  "library": {
    "noItems": "עוד לא הוספת דברים…",
    "hint_emptyLibrary": "נא לבחור משהו בקנבס כדי להוסיף אותו לכאן, או להתקין ספרייה מהמאגר הציבורי שלמטה.",
    "hint_emptyPrivateLibrary": "נא לבחור משהו בקנבס כדי להוסיף אותו לכאן.",
    "search": {
      "inputPlaceholder": "",
      "heading": "",
      "noResults": "",
      "clearSearch": ""
    }
  },
  "search": {
    "title": "איתור בלוח הציור",
    "noMatch": "לא נמצאו תוצאות…",
    "singleResult": "תוצאה",
    "multipleResults": "תוצאות",
    "placeholder": "איתור טקסט בלוח הציור…",
    "frames": "",
    "texts": ""
  },
  "buttons": {
    "clearReset": "איפוס לוח הציור",
    "exportJSON": "ייצוא לקובץ",
    "exportImage": "ייצוא התמונה…",
    "export": "שמירה אל…",
    "copyToClipboard": "העתקה ללוח",
    "copyLink": "העתקת קישור",
    "save": "שמירה לקובץ הנוכחי",
    "saveAs": "שמירה בשם",
    "load": "פתיחה",
    "getShareableLink": "קבלת קישור לשיתוף",
    "close": "סגירה",
    "selectLanguage": "בחירת שפה",
    "scrollBackToContent": "גלילה בחזרה לתוכן",
    "zoomIn": "הגדלה",
    "zoomOut": "הקטנה",
    "resetZoom": "איפוס תקריב",
    "menu": "תפריט",
    "done": "בוצע",
    "edit": "עריכה",
    "undo": "ביטול",
    "redo": "ביצוע מחדש",
    "resetLibrary": "איפוס ספרייה",
    "createNewRoom": "יצירת חדר חדש",
    "fullScreen": "מסך מלא",
    "darkMode": "מצב כהה",
    "lightMode": "מצב בהיר",
    "systemMode": "מצב מערכת",
    "zenMode": "מצב ריכוז",
    "objectsSnapMode": "הצמדה לעצמים",
    "exitZenMode": "יציאה ממצב ריכוז",
    "cancel": "ביטול",
    "saveLibNames": "",
    "clear": "ניקוי",
    "remove": "הסרה",
    "embed": "להציג את ההטמעה",
    "publishLibrary": "",
    "submit": "שליחה",
    "confirm": "אישור",
    "embeddableInteractionButton": "לחיצה לתפעול"
  },
  "alerts": {
    "clearReset": "פעולה זו תנקה את כל לוח הציור. להמשיך?",
    "couldNotCreateShareableLink": "יצירת קישור לשיתוף נכשלה.",
    "couldNotCreateShareableLinkTooBig": "יצירת קישור לשיתוף נכשלה: הסצנה גדולה מדי",
    "couldNotLoadInvalidFile": "טעינת קובץ לא תקין נכשלה",
    "importBackendFailed": "ייבוא מהמנגנון נכשל.",
    "cannotExportEmptyCanvas": "לא ניתן לייצא לוח ציור ריק.",
    "couldNotCopyToClipboard": "לא ניתן להעתיק ללוח.",
    "decryptFailed": "פענוח הצפנת הנתונים נכשל.",
    "uploadedSecurly": "ההעלאה אובטחה באמצעות הצפנה מקצה לקצה, פירוש הדבר שהשרת של Excalidraw וגורמי צד ג׳ לא יכולים לקרוא את התוכן.",
    "loadSceneOverridePrompt": "טעינה של ציור חיצוני תחליף את התוכן הקיים שלך. האם תרצה להמשיך?",
    "collabStopOverridePrompt": "עצירת השיתוף תוביל למחיקת הציור הקודם ששמור מקומית בדפדפן. האם אתה בטוח?\n\n(אם תרצה לשמור את הציור המקומי, סגור את הטאב של הדפדפן במקום.)",
    "errorAddingToLibrary": "לא ניתן להוסיף פריט לספרייה",
    "errorRemovingFromLibrary": "לא ניתן להסיר פריט מהספריה",
    "confirmAddLibrary": "זה יוסיף {{numShapes}} צורה(ות) לספריה שלך. האם אתה בטוח?",
    "imageDoesNotContainScene": "נראה שהתמונה לא מכילה מידע על הסצינה. האם אפשרת הטמעת מידע הסצינה בעת השמירה?",
    "cannotRestoreFromImage": "לא הצלחנו לשחזר את הסצנה מקובץ התמונה",
    "invalidSceneUrl": "ייבוא מידע סצנה מהקישור שסופק כשל. או שהוא משובש, או שאינו מכיל מידע של Excalidraw בפורמט JSON.",
    "resetLibrary": "פעולה זו תנקה את כל הספריה שלך. אתה בטוח?",
    "removeItemsFromsLibrary": "מחק {{count}} פריט(ים) מהספריה?",
    "invalidEncryptionKey": "מפתח ההצפנה חייב להיות בן 22 תוים. השיתוף החי מנוטרל.",
    "collabOfflineWarning": "אין חיבור זמין לאינטרנט.\nהשינויים שלך לא ישמרו!",
    "localStorageQuotaExceeded": ""
  },
  "errors": {
    "unsupportedFileType": "סוג הקובץ אינו נתמך.",
    "imageInsertError": "לא ניתן היה להוסיף את התמונה. אנא נסה שוב מאוחר יותר...",
    "fileTooBig": "הקובץ גדול מדי. הגודל המירבי המותר הינו {{maxSize}}.",
    "svgImageInsertError": "לא ניתן היה להוסיף את תמונת ה-SVG. הסימונים בתוך קובץ ה-SVG עשויים להיות שגויים.",
    "failedToFetchImage": "משיכת התמונה נכשלה.",
    "cannotResolveCollabServer": "לא הצלחתי להתחבר לשרת השיתוף. אנא רענן את הדף ונסה שוב.",
    "importLibraryError": "לא ניתן היה לטעון את הספריה",
    "saveLibraryError": "שמירת הספריה בזיכרון לא הצליחה. יש לשמור את הספריה מקומית כקובץ כדי לוודא שהשינויים לא ילכו לאיבוד.",
    "collabSaveFailed": "לא הצלחתי להתחבר למסד הנתונים האחורי. אם הבעיה ממשיכה, כדאי שתשמור את הקובץ מקומית כדי לוודא שלא תאבד את העבודה שלך.",
    "collabSaveFailed_sizeExceeded": "לא הצלחתי לשמור למסד הנתונים האחורי, נראה שהקנבס שלך גדול מדי. כדאי שתשמור את הקובץ מקומית כדי לוודא שלא תאבד את העבודה שלך.",
    "imageToolNotSupported": "תמונות מושבתות.",
    "brave_measure_text_error": {
      "line1": "נראה שהנכם משתמשים בדפדפן Brave אשר מוגדר<bold>למנוע באופן אגרסיבי חתימה אלקטרונית</bold>.",
      "line2": "ההגדרה הזאת יכולה לשבור את<bold>רכיבי הטקסט</bold> בעבודתך.",
      "line3": "אנו ממליצים לבטל את ההגדרה הזו. תוכלו ללמוד <link>כאן</link> כיצד לעשות זאת.",
      "line4": "אם ביטול ההגדרה אינו מתקן את הצגת רכיבי הטקסט אנא פתחו סוגיה בדף ה<issueLink>גיטהאב</issueLink> או כתבו לנו <discordLink>בדיסקורד</discordLink>"
    },
    "libraryElementTypeError": {
      "embeddable": "אי אפשר להוסיף רכיבי הטמעה לספרייה.",
      "iframe": "אי אפשר להוסיף רכיבי מסגרות שיבוץ (IFrame) לספרייה.",
      "image": "תמיכה בהוספת תמונות לספרייה תושק בקרוב!"
    },
    "asyncPasteFailedOnRead": "לא ניתן להדביק (אי אפשר לקרוא מלוח המערכת).",
    "asyncPasteFailedOnParse": "לא ניתן להדביק.",
    "copyToSystemClipboardFailed": "לא ניתן להעתיק ללוח."
  },
  "toolBar": {
    "selection": "בחירה",
    "lasso": "",
    "image": "הוספת תמונה",
    "rectangle": "מלבן",
    "diamond": "יהלום",
    "ellipse": "אליפסה",
    "arrow": "חץ",
    "line": "קו",
    "freedraw": "צייר",
    "text": "טקסט",
    "library": "ספריה",
    "lock": "השאר את הכלי הנבחר פעיל גם לאחר סיום הציור",
    "penMode": "מצב עט - מנע נגיעה",
    "link": "הוספת / עדכון קישור לצורה מסוימת",
    "eraser": "מחק",
    "frame": "כלי מסגרת",
    "magicframe": "תרשים קווי מתאר לקוד",
    "embeddable": "הטמעה באתר",
    "laser": "סמן לייזר",
    "hand": "יד (כלי הזזה)",
    "extraTools": "כלים נוספים",
    "mermaidToExcalidraw": "Mermaid ל־Excalidraw",
    "convertElementType": ""
  },
  "element": {
    "rectangle": "מלבן",
    "diamond": "יהלום",
    "ellipse": "אליפסה",
    "arrow": "חץ",
    "line": "קו",
    "freedraw": "ציור חופשי",
    "text": "טקסט",
    "image": "תמונה",
    "group": "קבוצה",
    "frame": "מסגרת",
    "magicframe": "מתרשים קווי מתאר לקוד",
    "embeddable": "הטמעה באתר",
    "selection": "בחירה",
    "iframe": "IFrame"
  },
  "headings": {
    "canvasActions": "פעולות קנבאס",
    "selectedShapeActions": "פעולות על הצורות שנבחרו",
    "shapes": "צורות"
  },
  "hints": {
    "dismissSearch": "",
    "canvasPanning": "",
    "linearElement": "לחץ להתחלת מספר נקודות, גרור לקו יחיד",
    "arrowTool": "",
    "arrowBindModifiers": "",
    "freeDraw": "לחץ וגרור, שחרר כשסיימת",
    "text": "טיפ: אפשר להוסיף טקסט על ידי לחיצה כפולה בכל מקום עם כלי הבחירה",
    "embeddable": "לחצו וגררו כדי ליצור הטמעת אתר",
    "text_selected": "",
    "text_editing": "",
    "linearElementMulti": "",
    "lockAngle": "",
    "resize": "",
    "resizeImage": "",
    "rotate": "",
    "lineEditor_info": "",
    "lineEditor_line_info": "",
    "lineEditor_pointSelected": "",
    "lineEditor_nothingSelected": "",
    "publishLibrary": "פרסם ספריה משלך",
    "bindTextToElement": "",
    "createFlowchart": "",
    "deepBoxSelect": "",
    "eraserRevert": "",
    "firefox_clipboard_write": "יכולות זה ניתנת להפעלה על ידי שינוי הדגל של \"dom.events.asyncClipboard.clipboardItem\" למצב \"true\". כדי לשנות את הדגל בדפדפן Firefox, בקר בעמוד ״about:config״.",
    "disableSnapping": "",
    "enterCropEditor": "",
    "leaveCropEditor": ""
  },
  "canvasError": {
    "cannotShowPreview": "לא ניתן להראות תצוגה מקדימה",
    "canvasTooBig": "הקנבס עלול להיות גדול מדי.",
    "canvasTooBigTip": "טיפ: נסה להזיז את הרכיבים הרחוקים ביותר מעט קרוב יותר האחד לשני."
  },
  "errorSplash": {
    "headingMain": "התעוררה איזו שגיאה. נא לנסות <button>לרענן את העמוד</button>.",
    "clearCanvasMessage": "אם טעינה מחדש לא עובדת, נסה ",
    "clearCanvasCaveat": " זה יגרום לאובדן העבודה ",
    "trackedToSentry": "השגיאה עם המזהה {{eventId}} במעקב במערכת שלך.",
    "openIssueMessage": "אנו נזהרים מאוד לא להכניס מידע על הסצנה שלך בתוך דיווח התקלה. אם הסצנה אינה פרטית, אנא שקלו לשלוח אותה ל<button>מעקב השגיאות שלנו</button>. אנא הוסיפו בתחתית הבאג מידע על ידי העתקה והדבקה לתוך הסוגיה ב-GitHub.",
    "sceneContent": "תוכן הקנבאס:"
  },
  "shareDialog": {
    "or": "או"
  },
  "roomDialog": {
    "desc_intro": "הזמנת משתתפים לעבודה משותפת.",
    "desc_privacy": "אל דאגה, סשן העבודה מוצפן מקצה לקצה והוא פרטי לגמרי. אפילו השרתים שלנו לא יכולים לראות מה ציירתם.",
    "button_startSession": "התחל שיתוף",
    "button_stopSession": "הפסק שיתוף",
    "desc_inProgressIntro": "שיתוף חי פעיל כרגע.",
    "desc_shareLink": "שתף את הקישור עם כל מי שאתה מעוניין לעבוד אתו:",
    "desc_exitSession": "עצירת השיתוף תנתק אותך מהחדר, אבל עדיין תוכל להמשיך לעבוד על הקנבאס, מקומית. שים לב שזה לא ישפיע על אנשים אחרים, והם עדיין יוכלו לבצע שיתוף עם הגרסה שלהם.",
    "shareTitle": "הצטרף לשיתוף לעבודה משותפת חיה, בזמן אמת, על גבי Excalidraw"
  },
  "errorDialog": {
    "title": "שגיאה"
  },
  "exportDialog": {
    "disk_title": "שמור לכונן",
    "disk_details": "ייצא מידע של הקנבאס לקובץ שתוכל לייבא אחר כך.",
    "disk_button": "שמירה לקובץ",
    "link_title": "קבל קישור לשיתוף",
    "link_details": "ייצוא כקישור לקריאה בלבד.",
    "link_button": "ייצוא לקישור",
    "excalidrawplus_description": "שמור את הקנבאס לסביבת העבודה שלך ב- +Excalidraw.",
    "excalidrawplus_button": "ייצוא",
    "excalidrawplus_exportError": "לא הצלחתי לייצא ל- +Excalidraw כרגע..."
  },
  "helpDialog": {
    "blog": "קרא את הבלוג שלנו",
    "click": "קליק",
    "deepSelect": "בחירה עמוקה",
    "deepBoxSelect": "בחירה עמוקה בתוך קופסה ומניעת גרירה",
    "createFlowchart": "יצירת תרשים זרימה מתוך רכיב רגיל",
    "navigateFlowchart": "ניווט בתוך תרשים הזרימה",
    "curvedArrow": "חץ מעוגל",
    "curvedLine": "קו מעוגל",
    "documentation": "תיעוד",
    "doubleClick": "לחיצה כפולה",
    "drag": "גרור",
    "editor": "עורך",
    "editLineArrowPoints": "עריכת נקודות קו/חץ",
    "editText": "עריכת טקסט / הוספת תווית",
    "github": "מצאת בעיה? דווח",
    "howto": "עקוב אחר המדריכים שלנו",
    "or": "או",
    "preventBinding": "למנוע נעיצת חיצים",
    "tools": "כלים",
    "shortcuts": "קיצורי מקלדת",
    "textFinish": "סיים עריכה (עורך טקסט)",
    "textNewLine": "הוסף שורה חדשה (עורך טקסט)",
    "title": "עזרה",
    "view": "תצוגה",
    "zoomToFit": "זום להתאמת כל האלמנטים למסך",
    "zoomToSelection": "התמקד בבחירה",
    "toggleElementLock": "נעילה/ביטול הנעילה של הרכיבים הנבחרים",
    "movePageUpDown": "זוז עמוד למעלה/למטה",
    "movePageLeftRight": "זוז עמוד שמאלה/ימינה",
    "cropStart": "חיתוך תמונה",
    "cropFinish": "סיים לחתוך תמונה"
  },
  "clearCanvasDialog": {
    "title": "ניקוי הקנבס"
  },
  "publishDialog": {
    "title": "פרסם ספריה",
    "itemName": "שם הפריט",
    "authorName": "שם היוצר",
    "githubUsername": "שם המשתמש שלך ב-GitHub",
    "twitterUsername": "שם המשתמש שלך ב-Twitter",
    "libraryName": "שם הספריה",
    "libraryDesc": "תיאור הספריה",
    "website": "אתר",
    "placeholder": {
      "authorName": "שמך או שם המשתמש שלך",
      "libraryName": "תנו שם לספריה",
      "libraryDesc": "תיאור של הספריה שלך כדי לסייע למשתמשים להבין את השימוש בה",
      "githubHandle": "כינוי GitHub (לא חובה), כדי שתוכל לערוך את הספרית לאחר שנשלחה לבדיקה",
      "twitterHandle": "שם משתמש טוויטר (לא חובה), כדי שנדע למי לתת קרדיט כשאנחנו מפרסמים בטוויטר",
      "website": "קישור לאתר הפרטי שלך או לכל מקום אחר (אופציונאלי)"
    },
    "errors": {
      "required": "נדרש",
      "website": "הזינו כתובת URL תקינה"
    },
    "noteDescription": "שלח את הספריה שלך כך שתצורף ל<link>מאגר הספריות הציבורי</link> כך שאנשים נוספים יוכלו להשתמש בה בעבודות שלהם.",
    "noteGuidelines": "תחילה הספריה נדרשת לעבור אישור ידני. אנא קראו את <link>הנחיות</link> לפני שאתם לוחצים על שליחה. יש צורך בחשבון GitHub כדי לתקשר ולבצע שינויים אם נדרש, אך אין זה הכרחי לשיתוף הספריה.",
    "noteLicense": "על ידי לחיצה על שליחה את/ה מסכימ/ה שהספריה תפורסם תחת <link>רישיון MIT</link>, אשר, בקצרה, מאפשר לכל אחד להשתמש בספריה ללא הגבלה.",
    "noteItems": "לכל פריט בסיפריה חייב להיות שם כדי שאפשר יהיה לסנן. הפריטי סיפריה הבאים יהיו כלולים:",
    "atleastOneLibItem": "אנא בחר לפחות פריט אחד מספריה כדי להתחיל",
    "republishWarning": "הערה: חלק מהפריטים שבחרת מסומנים ככאלו שכבר פורסמו/נשלחו. אתה צריך לשלוח פריטים מחדש כאשר אתה מעדכן ספריה או הגשה קיימים."
  },
  "publishSuccessDialog": {
    "title": "הספריה הוגשה",
    "content": "תודה {{authorName}}. הספריה שלך נשלחה לבחינה. תוכל לעקוב אחרי סטטוס הפרסום"
  },
  "confirmDialog": {
    "resetLibrary": "איפוס ספריה",
    "removeItemsFromLib": "הסר את הפריטים הנבחרים מהספריה"
  },
  "imageExportDialog": {
    "header": "ייצוא תמונה",
    "label": {
      "withBackground": "רקע",
      "onlySelected": "רק את מה שנבחר",
      "darkMode": "מצב כהה",
      "embedScene": "הטמעת סצנה",
      "scale": "קנה מידה",
      "padding": "ריפוד"
    },
    "tooltip": {
      "embedScene": "הייצוא יבוצע לקובץ מסוג PNG/SVG כדי שהמידע על הסצנה ישמר בו וניתן יהיה לבצע שחזור ממנו.\nיגדיל את גודל הקובץ של הייצוא."
    },
    "title": {
      "exportToPng": "ייצוא ל־PNG",
      "exportToSvg": "ייצוא ל־SVG",
      "copyPngToClipboard": "העתקת PNG ללוח"
    },
    "button": {
      "exportToPng": "PNG",
      "exportToSvg": "SVG",
      "copyPngToClipboard": "העתקה ללוח"
    }
  },
  "encrypted": {
    "tooltip": "הציורים שלך מוצפנים מקצה לקצה כך שהשרתים של Excalidraw לא יראו אותם לעולם.",
    "link": "פוסט בבלוג על הצפנה מקצה לקצב ב-Excalidraw"
  },
  "stats": {
    "angle": "זווית",
    "shapes": "צורות",
    "height": "גובה",
    "scene": "תצוגה",
    "selected": "נבחר",
    "storage": "אחסון",
    "fullTitle": "הגדרות הקנבס והצורות",
    "title": "מאפיינים",
    "generalStats": "כללי",
    "elementProperties": "מאפייני צורה",
    "total": "סה״כ",
    "version": "גרסה",
    "versionCopy": "לחץ להעתקה",
    "versionNotAvailable": "הגרסה אינה זמינה",
    "width": "רוחב"
  },
  "toast": {
    "addedToLibrary": "נוסף לספריה",
    "copyStyles": "סגנונות הועתקו.",
    "copyToClipboard": "הועתק ללוח.",
    "copyToClipboardAsPng": "{{exportSelection}} הועתקה ללוח כ-PNG\n({{exportColorScheme}})",
    "copyToClipboardAsSvg": "{{exportSelection}} הועתקה ללוח כ-SVG\n({{exportColorScheme}})",
    "fileSaved": "קובץ נשמר.",
    "fileSavedToFilename": "נשמר לקובץ {filename}",
    "canvas": "קנבאס",
    "selection": "בחירה",
    "pasteAsSingleElement": "השתמש ב- {{shortcut}} כדי להדביק כפריט יחיד,\nאו הדבק לתוך עורך טקסט קיים",
    "unableToEmbed": "הטמעת כתובת הרשת הזו אינה מותרת לעת עתה. העלו סוגיה ב-GitHub כדי לבקש שכתובת זו תכנס לרשימה המותרת",
    "unrecognizedLinkFormat": "הקישור שהוטמע אינו בפורמט המצופה. אנא נסו להדביק מחדש את מחרוזת ההטמעה מהאתר המבוקש",
    "elementLinkCopied": "קישור הועתק ללוח"
  },
  "colors": {
    "transparent": "שקוף",
    "black": "שחור",
    "white": "לבן",
    "red": "אדום",
    "pink": "ורוד",
    "grape": "ענבים",
    "violet": "סגול",
    "gray": "אפור",
    "blue": "כחול",
    "cyan": "ציאן",
    "teal": "ירוק-כחול",
    "green": "ירוק",
    "yellow": "צהוב",
    "orange": "כתום",
    "bronze": "ברונזה"
  },
  "welcomeScreen": {
    "app": {
      "center_heading": "",
      "center_heading_line2": "",
      "center_heading_line3": "",
      "center_heading_plus": "אתה רוצה ללכת אל Excalidraw+ במקום?",
      "menuHint": "ייצוא, העדפות, שפות, ..."
    },
    "defaults": {
      "menuHint": "ייצוא, העדפות, ועוד...",
      "center_heading": "איורים. נעשים. פשוטים.",
      "toolbarHint": "בחר כלי & והתחל לצייר!",
      "helpHint": "קיצורים & עזרה"
    }
  },
  "colorPicker": {
    "color": "",
    "mostUsedCustomColors": "הצבעים המותאמים הכי נפוצים",
    "colors": "צבעים",
    "shades": "הצללות",
    "hexCode": "קוד הקסדצימלי",
    "noShades": "אין הצללות זמינות לצבע הזה"
  },
  "overwriteConfirm": {
    "action": {
      "exportToImage": {
        "title": "ייצוא כתמונה",
        "button": "ייצוא כתמונה",
        "description": "ייצוא נתוני הסצנה כתמונה אותה אפשר לייבא בהמשך."
      },
      "saveToDisk": {
        "title": "שמירה לכונן",
        "button": "שמירה לכונן",
        "description": "ייצוא נתוני הסצנה לקובץ אותו אפשר לייבא בהמשך."
      },
      "excalidrawPlus": {
        "title": "Excalidraw+‎",
        "button": "ייצוא ל־Excalidraw+‎",
        "description": "שמירת הסצנה לסביבת העבודה שלך ב־+Excalidraw."
      }
    },
    "modal": {
      "loadFromFile": {
        "title": "טעינה מקובץ",
        "button": "טעינה מקובץ",
        "description": "טעינת הקובץ <bold>תחליף את התוכן הקיים</bold>.<br></br>אתם יכולים לגבות את העבודה שלכם תחילה בעזרת האפשרויות שלהלן."
      },
      "shareableLink": {
        "title": "טעינה מקישור",
        "button": "החלפת התוכן שלי",
        "description": "טעינת הקובץ <bold>תחליף את התוכן הקיים</bold>.<br></br>אתם יכולים לגבות את העבודה שלכם תחילה בעזרת האפשרויות שלהלן."
      }
    }
  },
  "mermaid": {
    "title": "Mermaid ל־Excalidraw",
    "button": "הוספה",
    "description": "לעת עתה נתמכים רק <flowchartLink>תרשימי זרימה</flowchartLink>, <sequenceLink>תהליכים</sequenceLink>, <classLink>ודיאגרמת מחלקה</classLink>. שאר הסוגים ייוצרו כתמונות ב-Excalidraw.",
    "syntax": "תחביר Mermaid",
    "preview": "תצוגה מקדימה",
    "label": "",
    "inputPlaceholder": ""
  },
  "ttd": {
    "error": ""
  },
  "chat": {
    "inputPlaceholder": "",
    "inputPlaceholderWithMessages": "",
    "generating": "",
    "rateLimitRemaining": "",
    "role": {
      "user": "",
      "assistant": "",
      "system": ""
    },
    "aiBeta": "",
    "label": "",
    "menu": "",
    "newChat": "",
    "deleteChat": "",
    "deleteMessage": "",
    "viewAsMermaid": "",
    "placeholder": {
      "title": "",
      "description": "",
      "hint": ""
    },
    "preview": "",
    "insert": "",
    "retry": "",
    "errors": {
      "promptTooShort": "",
      "promptTooLong": "",
      "generationFailed": "",
      "invalidDiagram": "",
      "fixInMermaid": "",
      "aiRepair": "",
      "requestAborted": "",
      "requestFailed": "",
      "mermaidParseError": ""
    },
    "rateLimit": {
      "messageLimit": "",
      "generalRateLimit": "",
      "messageLimitInputPlaceholder": ""
    },
    "upsellBtnLabel": ""
  },
  "quickSearch": {
    "placeholder": "חיפוש מהיר"
  },
  "fontList": {
    "badge": {
      "old": "ישן"
    },
    "sceneFonts": "בסצינה הנוכחית",
    "availableFonts": "הפונטים הקיימים",
    "empty": "לא נמצאו פונטים"
  },
  "userList": {
    "empty": "לא נמצאו משתמשים",
    "hint": {
      "text": "יש ללחוץ על משתמש כדי לעקוב",
      "followStatus": "המשתמש ברשימת המעקב שלך",
      "inCall": "המשתמש בשיחה קולית",
      "micMuted": "המיקרופון של המשתמש מושתק",
      "isSpeaking": "המשתמש מדבר"
    }
  },
  "commandPalette": {
    "title": "לוח פקודות",
    "shortcuts": {
      "select": "בחירה",
      "confirm": "אישור",
      "close": "סגירה"
    },
    "recents": "בשימוש לאחרונה",
    "search": {
      "placeholder": "תפריטי חיפוש, פקודות ואבני חן נעלמות",
      "noMatch": "אין פקודות תואמות…"
    },
    "itemNotAvailable": "הפקודה לא זמינה…",
    "shortcutHint": "ללוח פקודות, יש להשתמש ב־{{shortcut}}"
  },
  "keys": {
    "ctrl": "",
    "option": "",
    "cmd": "",
    "alt": "",
    "escape": "",
    "enter": "",
    "shift": "",
    "spacebar": "",
    "delete": "",
    "mmb": ""
  }
}
